import {create} from 'zustand'
import {devtools} from "zustand/middleware";

const initialState = {
    serviceId: null,
    vehicleId: null,
    vehicle: null,
    activeStep: null,
}

const useOrderStore = create(
    devtools((set) => ({
            ...initialState,
            setServiceId: (serviceId) => {
                set({serviceId: serviceId});
            },
            setVehicleId: (vehicleId) => {
                set({vehicleId: vehicleId});
            },
            setVehicle: (vehicle) => {
                set({vehicle: vehicle});
            },
            setActiveStep: (step) => {
                set({activeStep: step});
            }
        }),
        {
            name: 'order-store',
        })
)

export default useOrderStore;